// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
export default class ReportingOrganizationTypes {
    public static readonly CANDIDATE: string = 'Candidate';
    public static readonly PAC: string = 'PAC';
    public static readonly PARTY: string = 'Party';
    public static readonly UNDEFINED: string = 'Undefined';
}
